import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Tag } from '@app/models/automation/tag';
import { DeviceType } from '@app/models/disciplinemanagement/device-type.model';
import { SystemType } from '@app/models/panelpricingwizard/system-type.model';
import { TagDataTypeHelper } from '@app/models/shared/tag-datatype.enum';

@Component({
  selector: 'app-tag-edit-modal',
  templateUrl: './tag-edit-modal.component.html',
  styleUrls: ['./tag-edit-modal.component.scss']
})
export class TagEditModalComponent implements OnInit {
  @Input() isVisible = false;
  @Input() selectedTag: Tag;
  @Input() filteredDeviceTypes: DeviceType[] = [];
  @Input() filteredSystemTypes: SystemType[] = [];
  
  @Output() save = new EventEmitter<Tag>();
  @Output() cancel = new EventEmitter<void>();
  @Output() typeSelected = new EventEmitter<DeviceType>();
  @Output() typeDeselected = new EventEmitter<DeviceType>();
  
  dataTypeOptions = TagDataTypeHelper.getAllOptions();
  deviceTypeSearchText = '';

  constructor() { }

  ngOnInit(): void {
  }

  get sortedAndFilteredDeviceTypes(): DeviceType[] {
    if (!this.filteredDeviceTypes) return [];
    
    let types = [...this.filteredDeviceTypes];
    
    // Filter by search text
    if (this.deviceTypeSearchText) {
      const searchLower = this.deviceTypeSearchText.toLowerCase();
      types = types.filter(dt => dt.name.toLowerCase().includes(searchLower));
    }
    
    // Sort alphabetically
    types.sort((a, b) => a.name.localeCompare(b.name));
    
    return types;
  }

  onSave() {
    this.save.emit(this.selectedTag);
  }

  onCancel() {
    this.cancel.emit();
  }

  isDeviceTypeSelected(deviceTypeId: number): boolean {
    return this.selectedTag && this.selectedTag.typeIds && this.selectedTag.typeIds.includes(deviceTypeId);
  }

  onDeviceTypeChange(deviceTypeId: number, event: any) {
    const isChecked = event.target.checked;
    if (!this.selectedTag.typeIds) {
      this.selectedTag.typeIds = [];
    }
    if (isChecked) {
      if (!this.selectedTag.typeIds.includes(deviceTypeId)) {
        this.selectedTag.typeIds.push(deviceTypeId);
      }
    } else {
      const index = this.selectedTag.typeIds.indexOf(deviceTypeId);
      if (index > -1) {
        this.selectedTag.typeIds.splice(index, 1);
      }
    }
  }
}

